module.exports = __webpack_public_path__ + "static/jeremy-galliani-567479-unsplash-bec4ae1ed9a9b86f73c860a891b9c916.jpg";